import { render, staticRenderFns } from "./FlawsBlock.vue?vue&type=template&id=c8e42c26&"
import script from "./FlawsBlock.vue?vue&type=script&lang=js&"
export * from "./FlawsBlock.vue?vue&type=script&lang=js&"
import style0 from "./FlawsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports